<template>
  <el-container style="height: 100%;">
    <el-aside class="sidebar" width="250px">
      <!-- logo -->
      <div class="logo">后台管理系统</div>
      <!-- menu -->
      <div>
        <el-menu router unique-opened style="margin-top: 10px; text-align: left; " background-color="#324157"
                 text-color="#bfcbd9" active-text-color="#20a0ff">
          <template v-for="item in menus">
            <template v-if="item.subs">
              <el-submenu :index="item.index" :key="item.index">
                <template slot="title">
                  <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                </template>
                <el-menu-item v-for="(sub,i) in item.subs" :key="i" :index="sub.index">
                  {{ sub.title }}
                </el-menu-item>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :index="item.index" :key="item.index">
                <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>

    </el-aside>

    <el-container>
      <el-header class="header">
        <div style="float: left; vertical-align: middle;">
          <el-select :value="cur_app" placeholder="选择企业" @change='onApplicationChange' style="width:400px">
            <el-option v-for="item in apps"
                       :key="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div style="float: right; padding-right: 5px;">
          <!-- head right -->
          <el-dropdown style="margin-left: 10px;" trigger="click" @command="onCommand">
                        <span style="font-size: 14px; cursor: pointer;">{{ username }}<i
                            class="el-icon-caret-bottom"/></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="main">
        <transition name="move" mode="out-in">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </transition>
      </el-main>

      <el-dialog title="修改密码" :visible.sync="formVisible" :close-on-click-modal="false">
        <el-form ref="form" :model="resetForm" size="mini">
          <el-form-item label="旧密码：" prop="password">
            <el-input type="password" v-model="resetForm.oldPassword" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newpwd">
            <el-input type="password" v-model="resetForm.newPassword" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="newpassword1">
            <el-input type="password" v-model="resetForm.newPassword1" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取 消</el-button>
          <el-button type="primary" @click.native.prevent="handleChangePassword">修改</el-button>
        </div>
      </el-dialog>

    </el-container>
  </el-container>
</template>

<script>
import Config from '@/conf'
import VueJsonEditor from "@/components/VueJsonEditor.vue";
import {Role} from "@/utils/constants";

export default {
  components: {VueJsonEditor},
  data() {
    return {
      apps: [],   // 项目集合,可分组
      cur_app: "",         // 当前选中的app
      menus: [],          // 项目对应菜单
      formVisible: false,
      resetForm: {
        userId:"",
        oldPassword: "",
        newPassword: "",
        newPassword1: "",
      },
      Role
    }
  },

  computed: {
    username() {
      const state = this.$store.state
      if (state.user != null) {
        return state.user.userId
      } else {
        return 'bad user'
      }
    },
    role() {
      const state = this.$store.state;
      return state.user.role;
    }
  },

  methods: {

    createApps() {
      let user = this.$store.state.user;
      let app = user.apps[0];
      if (app === this.cur_app) {
        return;
      }
      this.apps = user.apps;
      this.onApplicationChange(app);
    },

    createMenus() {
      let app = this.$store.state.app
      let menus = []
      if (app != '') {

        menus = Config[this.formatAppType(app)].menus;
      }

      if (menus != this.menus) {
        this.menus = menus
        // TODO:check has menu
      }
    },

    formatAppType(app) {
      return app.split('|')[1];
    },

    formatAppName(app) {
      return app.split('|')[0];
    },

    onCommand(cmd) {
      switch (cmd) {
        case 'logout':
          this.$store.commit("logout")
          this.$router.push('/login')
          break
        case 'changePassword':
          this.formVisible = true;
          break;
      }
    },

    handleChangePassword() {
      let params = this.resetForm;
      this.$axios.post('/auth/reset/password', params).then(res => {
        this.$message.info('修改成功');
        this.onCommand('logout');
      }).catch(res => {})
    },

    onApplicationChange(app) {
      if (app === '') {
        this.$message("该环境下暂无配置");
        this.$conf = null;
        return;
      }
      // 根据项目初始化menus
      this.$store.commit("changeApp", app);
      this.$conf = Config[app];
      this.cur_app = app;
      this.createMenus();
      // this.refreshView();
    },

    refreshView() {
      this.$router.replace('/home')
    }

  },

  created() {
    this.createApps()
  }
}
</script>

<style scoped>
.sidebar {
  background-color: #324157;
  color: #333;
  text-align: center;
  height: 100%;
}

.logo {
  background-color: #002140;
  color: #fff;
  text-align: center;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
}

.header {
  /* background-color: #B3C0D1; */
  /* color: #333; */
  background-color: #fff;
  color: #939393;
  text-align: center;
  height: 70px;
  line-height: 60px;
  vertical-align: middle;
}

.main {
  background-color: #f0f2f5
}

</style>
